import { render, staticRenderFns } from "./PazienteDiarioComponent.vue?vue&type=template&id=43a888b5&scoped=true"
import script from "./PazienteDiarioComponent.vue?vue&type=script&lang=js"
export * from "./PazienteDiarioComponent.vue?vue&type=script&lang=js"
import style0 from "./PazienteDiarioComponent.vue?vue&type=style&index=0&id=43a888b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a888b5",
  null
  
)

export default component.exports